import {
  convertToCamelCase,
  convertToSnakeCase,
} from "../redux/actions/helpers";
import { dataFormatter } from "./index";
import axios from "axios";
import Cookies from "js-cookie";

export const loadCurrentUser = async (cancelToken) => {
  const response = await axios
    .get("/api/v1/users/me", {
      headers: {
        Authorization: `Bearer ${
          Cookies.get("jwt") || localStorage.getItem("jwt")
        }`,
        cancelToken: cancelToken,
      },
    })
    .catch((error) => {
      throw error;
    });

  if (response.status === 200) {
    return convertToCamelCase(dataFormatter.deserialize(response.data));
  }
};

export const submitLoginForm = async (formData) => {
  const response = await axios
    .post("/api/v1/authenticate", {
      auth: {
        email: formData.email,
        password: formData.password,
        type: formData.type,
      },
    })
    .catch((errors) => {
      throw errors;
    });

  if (response.status === 200) {
    Cookies.set("jwt", response.data.jwt);
    if (formData.rememberMe) {
      localStorage.setItem("jwt", response.data.jwt);
    } else {
      localStorage.removeItem("jwt");
    }
    return response.data.jwt;
  }
};

export const updateProfile = async (formData, id) => {
  const response = await axios
    .put(
      `/api/v1/users/${id}`,
      {
        data: { attributes: convertToSnakeCase(formData) },
      },
      {
        headers: {
          Authorization: `Bearer ${
            Cookies.get("jwt") || localStorage.getItem("jwt")
          }`,
        },
      }
    )
    .catch((error) => {
      throw error;
    });

  if (response.status === 200) {
    return convertToCamelCase(dataFormatter.deserialize(response.data));
  }
};

export const submitSignUpForm = async (formData) => {
  const response = await axios
    .post(
      "/api/v1/users",
      {
        data: { attributes: convertToSnakeCase(formData) },
      },
      {
        headers: {
          Authorization: `Bearer ${
            Cookies.get("jwt") || localStorage.getItem("jwt")
          }`,
        },
      }
    )
    .catch((error) => {
      throw error;
    });

  if (response.status === 200) {
    return convertToCamelCase(dataFormatter.deserialize(response.data));
  }
};

export const activateAccount = async (otp, jwt) => {
  const response = await axios
    .put("account_activation/confirmation", {
      account_activation: {
        otp: otp,
        jwt: jwt,
      },
    })
    .catch((errors) => {
      throw errors;
    });

  if (response.status === 200) {
    return convertToCamelCase(dataFormatter.deserialize(response.data));
  }
};

export const sendPasswordReset = async (formData) => {
  const response = await axios
    .post("password_reset", {
      password_reset: formData,
    })
    .catch((errors) => {
      throw errors;
    });

  if (response.status === 200) {
    return convertToCamelCase(dataFormatter.deserialize(response.data));
  }
};

export const resetPassword = async (formData) => {
  const response = await axios
    .put("password_reset", {
      password_reset: {
        password: formData.password,
        password_confirmation: formData.password_confirmation,
        jwt: formData.jwt,
      },
    })
    .catch((errors) => {
      throw errors;
    });

  if (response.status === 200) {
    return convertToCamelCase(dataFormatter.deserialize(response.data));
  }
};

export const passwordResetValidation = async (otp, jwt) => {
  const response = await axios
    .post("password_reset/password_reset_validation", {
      password_reset: { otp: otp, jwt: jwt },
    })
    .catch((errors) => {
      throw errors;
    });

  if (response.status === 200) {
    return convertToCamelCase(dataFormatter.deserialize(response.data));
  }
};
